import { render, staticRenderFns } from "./konectVan.vue?vue&type=template&id=30781d64&scoped=true&"
import script from "./konectVan.vue?vue&type=script&lang=js&"
export * from "./konectVan.vue?vue&type=script&lang=js&"
import style0 from "./konectVan.vue?vue&type=style&index=0&id=30781d64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30781d64",
  null
  
)

export default component.exports